<template>
    <BreadCrumb PageTitle="Modifier une inscription" />
    <EditInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditInscription from "@/components/Inscription/EditInscription.vue";
  
    export default defineComponent({
      name: "EditInscriptionPage",
      components: {
        BreadCrumb,
        EditInscription,
      },
    });
  </script>